export default class FooterNav {
  constructor() {
    this.items = document.querySelectorAll('#footerNav li');
    this.resizeTimer = null;
    this.addClassToLastItemInRow = this.addClassToLastItemInRow.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  init() {
    window.addEventListener('load', this.addClassToLastItemInRow);
    window.addEventListener('resize', this.handleResize);
  }

  addClassToLastItemInRow() {
    let lastItem = null;
    this.items.forEach((item) => {
      item.classList.remove('-endRow');
      if (lastItem && item.offsetTop > lastItem.offsetTop) {
        lastItem.classList.add('-endRow');
      }
      lastItem = item;
    });
  }

  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.addClassToLastItemInRow();
    }, 250);
  }
}
